import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AutoFocusModule } from 'primeng/autofocus';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';

@Component({
    selector: 'filter-by-search-and-order',
    templateUrl: './filter-by-search-and-order.component.html',
    standalone: true,
    imports: [SpanTooltipComponent, NgClass, OverlayPanelModule, SharedModule, FormsModule, AutoFocusModule, AfTranslatePipe]
})
export class FilterBySearchAndOrderComponent implements OnChanges{
  // isLanding: Boolean = this.route.snapshot.data['isLanding'];
  filterBySearch: any = {
    id: this.commonUtilsService.createId(),
    filterSearch: [{action:'search'}],
    selectedOption: [],
    inputFilter: '',
    userLogin: this.context.user,
    orderBy: 'nameToShow',
    name: '',
  }

  constructor(
    private context: ContextFactory,
    private commonUtilsService: CommonUtilsService
  ) { }

  @Input() item: any;
  @Input() filterOrder: string | any;
  @Input() order: boolean = false;
  @Input() typeOverlay: string = 'overlay';
  @Output() launchActionFilterOrderEmit = new EventEmitter();
  @ViewChild(OverlayPanel) dropdown: OverlayPanel;
  @ViewChild('filterContainer') filterContainer: ElementRef;

  ngAfterViewInit(): void {
    this.commonUtilsService.bindScrollOverlayListener(this.dropdown);
  }

  ngOnChanges(): void {
    if(this.item){
      this.filterBySearch.label = this.item.textColumn?this.item.textColumn:this.item.name;
    }
  }

  filterSearch(){
    this.launchActionFilterOrderEmit.emit({newValue: this.item.value, action: 'search'});
  }

  resetFilter(){
    this.item.value = '';
    this.launchActionFilterOrderEmit.emit({newValue: this.item.value, action: 'search'});
  }

  orderColumn(){
    this.launchActionFilterOrderEmit.emit({newValue: this.item.filterOrder, action: 'order'});
  }

  toggleFilter(e: any){
    this.commonUtilsService.toggleFilterOverlay(e, this.dropdown, this.typeOverlay, this.filterContainer.nativeElement);
  }
}
